import { render, staticRenderFns } from "./EmployeeCoursesRegistration.vue?vue&type=template&id=3cb994b2&scoped=true"
import script from "./EmployeeCoursesRegistration.vue?vue&type=script&lang=js"
export * from "./EmployeeCoursesRegistration.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCoursesRegistration.vue?vue&type=style&index=0&id=3cb994b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb994b2",
  null
  
)

export default component.exports